export function withHeader(token) {
  return {
    headers: {Authorization: 'Bearer ' + token}
  };
};
